import React from "react";
import useBrand from "@RHCommerceDev/hooks/useBrand";
import { useLocalization } from "@RHCommerceDev/hooks/useLocalization";
import RHRBabyChildIcon from "@RHCommerceDev/icon-babychild-rhr";
import RHROutdoorIcon from "@RHCommerceDev/icon-outdoor-rhr";
import RHRTeenIcon from "@RHCommerceDev/icon-teen-rhr";
import WORHIcon from "@RHCommerceDev/icon-worh";

const BrandIcons = {
  TN: (
    <RHRTeenIcon className="h-[46px] w-12 text-inherit sm:h-[57.429px]  sm:w-[60px] lg:h-16 lg:w-[66.86px]" />
  ),
  BC: (
    <RHRBabyChildIcon className="h-[46px] w-12 text-inherit sm:h-[57.429px]  sm:w-[60px] lg:h-16 lg:w-[66.86px]" />
  ),
  OD: <RHROutdoorIcon className="h-[17px] w-[215px] text-inherit" />,
  RH: (
    <WORHIcon className="h-[46px] w-12 text-inherit sm:h-[57.429px]  sm:w-[60px] lg:h-16 lg:w-[66.86px]" />
  )
};

const BrandLogo = () => {
  const brand = useBrand();
  const locale = useLocalization();

  const getBrandIcon = brand => {
    const brandIcon =
      brand in BrandIcons
        ? BrandIcons[brand as keyof typeof BrandIcons]
        : BrandIcons.RH;
    return brandIcon;
  };

  return (
    <a href={locale} className="h-min w-min text-inherit" data-analytics-worhlogo="homepage-logo">
      {getBrandIcon(brand)}
    </a>
  );
};

export default BrandLogo;
